export enum GSIDismissedReason {
	CREDENTIAL_RETURNED = 'credential_returned',
}

export interface GSINotification {
	isSkippedMoment: () => boolean | undefined;
	getDismissedReason: () => GSIDismissedReason | undefined;
	isDisplayed: () => boolean | undefined;
}
